function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.339 4.277L3.836.761l3.497 3.516H4.755v6.476h-1.84V4.277H.339z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 8 11"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/statictics-arrow.ff754e89.svg";
export { SvgComponent as ReactComponent };